import React from 'react';
import apple from '../../images/app-store-badge.svg';
import google from '../../images/play-store-badge.png';
import Touch from '../Touch';
import CloseIcon from '../common/CloseIcon';
import useInterval from '../../helper/useInterval';

const HouseAdBanner = ({onClose}) => {
  console.log('HouseAdBanner.render()');

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isAndroid = /Android/.test(navigator.userAgent);

  const textArray = [
    "Super einfach, schnell und übersichtlich. Jetzt unsere Fußball App installieren!",
    "Wie diese Webseite, nur besser! Jetzt unsere Fußball Ergebnisse App laden!",
    "Alle Fußballergebnisse auf einen Blick. Hol dir jetzt unsere App!",
    'Dunkelmodus? 🌙 🌑 Klar! In unserer Fußball Ergebnisse App!',
    'Fußball Nachrichten? 📰 Klar! In unserer Fußball Ergebnisse App!',
    'Mannschaften farbig hervorheben 🔴🟠🟡🟢🔵🟣, jetzt in unserer App!'
  ];

  const [visible, setVisible] = React.useState(true);
  const [text, setText] = React.useState(textArray[Math.floor(Math.random() * textArray.length)]);

  useInterval(() => {
    setText(textArray[Math.floor(Math.random() * textArray.length)]);
  }, 30000);

  if (!visible) {
    return null;
  }

  if (!isIOS && !isAndroid) {
    onClose();
    return null;
  }

  return (
    <div style={styles.container}>
      <a
        href={
          isIOS ? "https://apps.apple.com/de/app/fu%C3%9Fball-ergebnisse-footy/id1602126180?pt=117271916&ct=fussball-ergebnis-de-footer&mt=8" : 
          isAndroid ? "http://play.google.com/store/apps/details?id=org.youfootball&utm_source=fussball-ergebnis-de-footer" :
          "#"
        }
        target="_blank"
        rel="noreferrer"
        style={styles.a}
      >
        <div style={styles.text}>
          {text}
        </div>
        {
          isIOS ? (
            <div style={styles.appStoreImage}>
              <img src={apple} alt="Apple App Store Badge"/>
            </div>
          ) : isAndroid ? (
              <img src={google} alt="Google Play Store Badge" style={styles.playStoreImage}/>
          ) : null
        }
      </a>
      <Touch
        style={styles.touch}
        onPress={() => { setVisible(false); onClose(); }}
      >
        <CloseIcon />
      </Touch>
      
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100%',
    height: 60,
    padding: 8,
    backgroundColor: '#f0f0f0',
    textAlign: 'center',
    boxShadow: '0 -2px 5px rgba(0,0,0,0.1)',
  },
  a: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center'
  },
  text: {
    display: 'flex',
    marginRight: 8,
    fontSize: 14,
    color: '#333',
    verticalAlign: 'middle',
  },
  touch: {
    marginLeft: 16,
    marginRight: 8,
  },
  appStoreImage: {
    minHeight: 40,
    minWidth: 120,
  },
  playStoreImage: {
    minHeight: 35,
    minWidth: 118,
    objectFit: 'contain'
  },
};

export default HouseAdBanner;
